// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_DeleteTicketInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /tickets/deleteTicket
 *
 * Deletes a ticket by ID.
 */
import { registerContract } from './validate'

export interface Tickets_DeleteTicketInput {
id: number
}

registerContract('Tickets_DeleteTicketInput', {
  id: { type: 'number',  required: true },
})
